import './Fractals.css';
import "../Common.css"

import useScript from '../useScript';

function Fractals()
{
    useScript('../js/fractals.js');
    //useScript('../js/mosaic.js');

    return (
        <div id="fractals"></div>
    )
}

export default Fractals;